import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/joy';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Stack from 'components/core/Stack';
import Sheet from 'components/core/Sheet';
import Card from 'components/core/Card';
import Input from 'components/core/Input';
import Button from 'components/core/Button';
import Typography from 'components/core/Typography';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import authActions from 'actions/authActions';

const UpdatePassword = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(({ auth }) => auth.me);
  const [passwords, setPasswords] = useState({ password: '', confirmPassword: '' });
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user?.get('changePassword')) {
      navigate('/');
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (passwords.password !== passwords.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (passwords.password.length < 8) {
      setError('Password must be at least 8 characters long');
      return;
    }

    try {
      const username = user.get('username');
      await dispatch(authActions.updatePassword(passwords.password));
      await dispatch(authActions.login(username, passwords.password));
      navigate('/');
    } catch (err) {
      setError('Failed to update password. Please try again.');
    }
  };

  return (
    <Sheet 
      sx={{
        margin: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        height: '100vh',
        backgroundImage: 'url(/api/placeholder/1920/1080)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'primary.50'
      }}
    >
      <Card
        sx={{
          width: '100%',
          maxWidth: 800,
          p: 8,
          background: 'rgba(255, 255, 255, 0.5)',
          backdropFilter: 'blur(10px)',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Stack spacing={4} alignItems="center" sx={{ width: '100%' }}>
          <img
            src={'./img/short_logo.png'}
            alt={''}
            width={160}
          />
          <Typography level="h4">Change Password</Typography>
          <form onSubmit={handleSubmit} style={{ width: '100%' }}>
            <Stack spacing={4} alignItems="center">
              <Input
                type="password"
                placeholder="New Password"
                value={passwords.password}
                onChange={(value) => setPasswords({
                  ...passwords,
                  password: value
                })}
                sx={{ width: '100%' }}
              />
              
              <Input
                type="password"
                placeholder="Confirm New Password"
                value={passwords.confirmPassword}
                onChange={(value) => setPasswords({
                  ...passwords,
                  confirmPassword: value
                })}
                sx={{ width: '100%' }}
              />
              
              {error && (
                <Typography color="danger" size="sm">
                  {error}
                </Typography>
              )}
              <Card sx={{background: theme.palette.primary[50]}}>
                  <Stack spacing={2} direction="row" alignItems="center">
                      <InfoOutlinedIcon sx={{color: theme.palette.primary.main}}/>
                      <Typography variant="body2" sx={{fontSize: 12}}>
                        Passwords must be 8 or more characters with at least one lowercase letter, uppercase letter, number, and special character (!, @, #, $, %, ^, &, *).
                      </Typography>
                  </Stack>
              </Card>
              <Button 
                type="submit"
                sx={{ width: '100%' }}
              >
                Change Password
              </Button>
            </Stack>
          </form>
        </Stack>
      </Card>
    </Sheet>
  );
};

export default UpdatePassword;